import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SharedService } from "../services/shared.service";
import { observable } from "knockout";
import { of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private accessTokentimeOut
    private refreshTokentimeOut
    headers = new HttpHeaders().set('Content-Type', 'application/json');

    constructor(
        private http: HttpClient,
        private sharedService: SharedService,
    ) { }

    requestAccessToken() {

        //Pressing login byutton initiates the timer to ask new access token and refresh token.

        this.startAccessTokenTimer()
        this.startRefreshTokenTimer()
    }
    accessToken(request = { "change_status": false, "customer": "" }) {
        if (sessionStorage.getItem('SRID')) {
            let refreshToken = sessionStorage.getItem('SRID')
            this.http.post(environment.apiUrl + '/login/auth/accessToken/get', request, { headers: { 'SRID': refreshToken }, observe: "response", withCredentials: true })
                .subscribe((response: any) => {
                    if (response.headers.has('SPL')) {
                        let payload = response.headers.get('SPL')
                        sessionStorage.setItem('SPL', payload)
                    }
                    if (response.headers.has('SRID')) {
                        let refreshToken = response.headers.get('SRID')
                        sessionStorage.setItem('SRID', refreshToken)
                    }
                    this.startAccessTokenTimer()
                }),
                (err) => {
//console.log(err)
                }
        }
    }

    refreshToken() {
        if (sessionStorage.getItem('SRID')) {
            let refreshToken = sessionStorage.getItem('SRID')
            this.http.post(environment.apiUrl + '/login/auth/refreshToken/get', {}, { headers: { 'SRID': refreshToken }, observe: "response", withCredentials: true })
                .subscribe((response: any) => {
                    if (response.headers.has('SPL')) {
                        let payload = response.headers.get('SPL')
                        sessionStorage.setItem('SPL', payload)
                    }
                    if (response.headers.has('SRID')) {
                        let refreshToken = response.headers.get('SRID')
                        sessionStorage.setItem('SRID', refreshToken)
                    }
                    this.startRefreshTokenTimer()
                }),
                (err) => {
//console.log(err)
                }
        }
    }

    startRefreshTokenTimer() {
        let refreshToken = JSON.parse(sessionStorage.getItem('SRID'))
        let refreshTokenSplitted = refreshToken.split('.')
        let refreshPayload = atob(refreshTokenSplitted[1])
        let refreshPayloadObj = JSON.parse(refreshPayload)
        let expire = new Date((refreshPayloadObj.exp - refreshPayloadObj.iat) * 1000)
        let timer = expire.getTime() - (10 * 60 * 1000)
        this.refreshTokentimeOut = setTimeout(() => this.refreshToken(), timer)
    }

    startAccessTokenTimer() {
        let payloadObj = atob(JSON.parse(sessionStorage.getItem('SPL')))
        let payload = JSON.parse(payloadObj)
        let expire = new Date((payload.exp - payload.iat) * 1000)
        let timer = expire.getTime() - (60 * 1000)
        this.accessTokentimeOut = setTimeout(() => this.accessToken(), timer)
    }

    logout() {
        // console.log(this.sharedService.$userLogged.getValue())
        if (this.sharedService.$userLogged.getValue()) {
            console.log("User logged")
            clearTimeout(this.accessTokentimeOut)
            clearTimeout(this.refreshTokentimeOut)
            this.sharedService.$userLogged.next(false)
            this.sharedService.$userLoggedoff.next(true)
            const username = this.sharedService.userName;
            // this.userLoginservice.userName = null;

            return this.http.post(environment.apiUrl + '/userlogin/logout/post',
                { "user_name": username }, { headers: this.headers, withCredentials: true })
        }else{
            console.log("User not logged")
            console.log("Empty return --> ",typeof(of({status:0})))
        //    return of({status : 0})
        }
    }

    closePreview() {
        if (this.sharedService.previewRef) {
          this.sharedService.previewRef?.close()
        }
      }

    terminate_session(){
        if (this.sharedService.$userLogged.getValue()) {
            clearTimeout(this.accessTokentimeOut)
            clearTimeout(this.refreshTokentimeOut)
            this.sharedService.$userLogged.next(false)
            this.sharedService.$userLoggedoff.next(true)
            this.closePreview()
            // this.userLoginservice.userName = null;
        }
    }

}